export const WORLD_CUP_ADMIN_SECTIONS = {
  STAGES: 'stages',
  TEAMS: 'teams',
  MATCHES: 'matches',
  CHAMPION: 'champion',
  LEADERBOARD: 'leaderboard',
}

export const GROUP_MATCHES_PER_ROUND = 24

export const KNOCKOUT_STAGE_TITLES = {
  'Round of 32': 'Round of 32',
  'Round of 16': 'Round of 16',
  'Quarter Final': 'Kvartfinaler',
  'Semi Final': 'Semifinaler',
  'Third Place Match': 'Bronzekamp',
  'Final': 'Finalen',
}

export const WORLD_CUP_ADMIN_SECTION_TITLES = {
  stages: 'VM-faser',
  teams: 'VM-hold',
  matches: 'Opret kamp',
  champion: 'Verdensmester',
  leaderboard: 'Leaderboard',
}

export const DEFAULT_STAGES = [
  { name: 'Group A', sortOrder: 1 },
  { name: 'Group B', sortOrder: 2 },
  { name: 'Group C', sortOrder: 3 },
  { name: 'Group D', sortOrder: 4 },
  { name: 'Group E', sortOrder: 5 },
  { name: 'Group F', sortOrder: 6 },
  { name: 'Group G', sortOrder: 7 },
  { name: 'Group H', sortOrder: 8 },
  { name: 'Group I', sortOrder: 9 },
  { name: 'Group J', sortOrder: 10 },
  { name: 'Group K', sortOrder: 11 },
  { name: 'Group L', sortOrder: 12 },
  { name: 'Round of 32', sortOrder: 13 },
  { name: 'Round of 16', sortOrder: 14 },
  { name: 'Quarter Final', sortOrder: 15 },
  { name: 'Semi Final', sortOrder: 16 },
  { name: 'Third Place Match', sortOrder: 17 },
  { name: 'Final', sortOrder: 18 },
]

export const emptyMatchForm = (stages = DEFAULT_STAGES) => ({
  id: '',
  homeTeam: '',
  awayTeam: '',
  kickoffTime: '',
  stage: stages[0]?.name || 'Group A',
  sortOrder: stages[0]?.sortOrder ?? 1,
  homeGoals: '',
  awayGoals: '',
  status: 'scheduled',
})
